const apiUrl = process.env.VUE_APP_API_URL
import axios from 'axios'
import { loadStripe } from '@stripe/stripe-js'
import CryptoJS from 'crypto-js'; // Ensure this is imported if not already

const stripePromise = loadStripe(process.env.VUE_APP_STRIPE_PK) //loadStripe(process.env.STRIPE_PK)

export default {
    async contactUsForm({ commit }, payLoad) {
        commit('setLoading', true)
        try {
            let { data } = await axios.post(apiUrl + 'users/support', payLoad)
            commit('setSuccess', data.message)
            commit('setLoading', false)
        } catch (errors) {
            commit('setLoading', false)
            commit('setError', errors.response.data.message)
        }
    },

    authLogin({ commit }, payLoad) {
        commit('setLoading', true)
        try {
            httpRequest['$auth']
                .login(payLoad)
                .then((response) => {

                    if(response && response.data && response.data.data)
                    {
                        response.data.data=CryptoJS.AES.decrypt(response.data.data, process.env.VUE_APP_IDENTIFIER).toString(CryptoJS.enc.Utf8)
                        response.data.data = JSON.parse(response.data.data)
                        if(response.data.data.accessToken)
                        {
                            commit('setSuccess', response.data.message)
                            commit('setToken', response.data.data.accessToken)
                            commit('setTokenExpiry', response.data.data.expiresIn)
                            commit('setUser', response.data.data.profile)
                            commit('setLoading', false)
                        }
                        else
                        {
                            commit('setError', "There is an error in logging your account, please try again later")
                        }
                    }
                    else
                    {
                        commit('setError', "There is an error in logging your account, please try again later")
                    }
                })
                .catch(function onError(error) {
                    commit('setLoading', false)
                    commit('setError', error.response.data.message)
                })
        } catch (errors) {
            console.log('----decrypt error----',errors)
            commit('setLoading', false)
            commit('setError', errors.response.data.message)
        }
    },
    async stripeCustomerPortalRedirect({ commit }, payLoad) {
        try {
            let { data } = await axios.post(apiUrl + 'users/billing', payLoad)
            commit('setSuccess', data.message)
            commit('setLoading', false)
            window.location.href = data.data.session
        } catch (errors) {
            commit('setLoading', false)
            commit('setError', errors.response.data.message)
        }
    },
    async createCheckoutSession({ commit }, payLoad) {
        try {
            let { data } = await axios.post(
                apiUrl + 'users/create-checkout-session',
                payLoad
            )
            const stripe = await stripePromise

            const result = await stripe.redirectToCheckout({
                sessionId: data.sessionId,
            })

            if (result.error) {
                // If `redirectToCheckout` fails due to a browser or network
                // error, display the localized error message to your customer
                // using `result.error.message`.
            }
            commit('setSuccess', data.message)
            commit('setLoading', false)
        } catch (errors) {
            commit('setLoading', false)
                //            commit('setError', errors.response)
            console.log(errors)
        }
    },
    async authLogout({ commit }) {
        try {
            let { data } = await axios.post(apiUrl + 'users/logout')
            commit('setUser', null)
            commit('setToken', null)
            commit('setTokenExpiry', null)
            commit('setSuccess', data.message)
            commit('setDataSegmentId', null)
            // localStorage.removeItem('dataSegmentId')
            // localStorage.removeItem('activeDataSegmentId')
            // localStorage.removeItem('vueauth_token')
            console.log('--------------uaePassLogin-----------',localStorage.getItem('uaePassLogin'))
            if(localStorage.getItem('uaePassLogin') && localStorage.getItem('uaePassLogin')=='true')
            {
                localStorage.clear()
                window.location.href = process.env.VUE_APP_UAE_PASS_URL+'idshub/logout?redirect_uri='+process.env.VUE_APP_API_URL+'users/uae-pass-callback';
            }
            localStorage.clear()

            // httpRequest.$auth
                //     .logout(payLoad)
                //     .then((response) => {
                //         commit('setUser', null)
                //         commit('setToken', null)
                //         commit('setSuccess', 'You have logged out successfully.')
                //     })
                //     .catch(function onError(error) {
                //         commit('setUser', null)
                //         commit('setToken', null)
                //         commit('setError', error.message)
                //     })
        } catch (error) {
            commit('setUser', null)
            commit('setToken', null)
            commit('setTokenExpiry', null)
            commit('setError', error.response.data.message)
        }
    },

    async authChangePassword({ commit }, payLoad) {
        try {
            commit('setLoading', true)
            let { data } = await axios.post(
                apiUrl + 'users/password/change',
                payLoad, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'vueauth_token'
                        )}`,
                    },
                }
            )
            commit('setSuccess', data.message)
            commit('setLoading', false)
            return true
        } catch ({ response }) {
            let { data } = response
            let message = 'There is someting wrong'
            if (data.errors && Object.keys(data.errors).length) {
                message = data.errors[Object.keys(data.errors)[0]]
            } else if (data.message) {
                message = data.message
            }

            commit('setLoading', false)
            commit('setError', message)
            return false
        }
    },

    async authForgotPassword({ commit }, payLoad) {
        try {
            console.log("Payload at action.js : ", payLoad)
            commit('setLoading', true)
            let { data } = await axios.post(
                apiUrl + 'users/password/reset',
                payLoad
            )
            console.log("Data at action.js", data)
            commit('setSuccess', data.message)
            commit('setData', data.message)
            commit('setLoading', false)
            return true
        } catch (errors) {
            commit('setLoading', false)
            commit('setError', errors.response.data.message)
        }
    },

    async authResetPassword({ commit }, { payLoad, token }) {
        try {
            commit('setLoading', true)
            let { data } = await axios.post(
                apiUrl + 'users/password/set/' + token,
                payLoad
            )
            commit('setSuccess', data.message)
            commit('setLoading', false)
            return true
        } catch ({ response }) {
            let { data } = response
            let message = 'There is someting wrong'
            if (data.errors && Object.keys(data.errors).length) {
                message = data.errors[Object.keys(data.errors)[0]]
            } else if (data.message) {
                message = data.message
            }

            commit('setLoading', false)
            commit('setError', message)
            return false
        }
    },

    async authCreatePassword({ commit }, { payLoad, token }) {
        try {
            commit('setLoading', true)
            let { data } = await axios.post(
                apiUrl + 'users/activate-account/' + token,
                payLoad
            )
            console.log("data", data)

            commit('setToken', data.data.accessToken)
            commit('setTokenExpiry', data.data.expiresIn)
            commit('setUser', data.data.profile)
            commit('setSuccess', data.message)
            commit('setLoading', false)
            commit('setDataSegmentId', data.data.profile.dataSegmentIds[0])

            return true
        } catch ({ response }) {
            let { data } = response
            let message = 'There is someting wrong'
            if (data.errors && Object.keys(data.errors).length) {
                message = data.errors[Object.keys(data.errors)[0]]
            } else if (data.message) {
                message = data.message
            }

            commit('setLoading', false)
            commit('setError', message)
            return false
        }
    },
    async authCreatePasswordForTeam({ commit }, { payLoad, token }) {
        try {
            commit('setLoading', true)
            console.log("token", token)
            let { data } = await axios.post(
                apiUrl + 'users/team-member/activate-account/' + token,
                payLoad
            )
            commit('setToken', data.data.accessToken)
            commit('setTokenExpiry', response.data.data.expiresIn)
            commit('setUser', data.data.profile)
            commit('setSuccess', data.message)
            commit('setLoading', false)
            return true
        } catch ({ response }) {
            let { data } = response
            let message = 'There is something wrong'
            if (data.errors && Object.keys(data.errors).length) {
                message = data.errors[Object.keys(data.errors)[0]]
            } else if (data.message) {
                message = data.message
            }

            commit('setLoading', false)
            commit('setError', message)
            return false
        }
    },
}